<template>
    <div class="gray-back" >

        <div class="list-box">
            <div class="lists flex-between" v-for="(item, index) in list"
                 @click="action(item, index)">
                <div class="rights">
                    <div class="title">{{item.name}}</div>
                    <div class="desc flex-start">
                        {{item.kaojitype}}
                    </div>
                </div>
            </div>
        </div>
        <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect" />

        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round  @click="showAddForm=true">新增邀请卡</van-button>
        </div>

        <van-popup v-model="showAddForm"
                   round
                   position="bottom"
                   :style="{ height: '30%' }"
        >
            <div class="poptitle">{{formData.id==0?'新建':'编辑'}}考级邀请函</div>
            <van-form
                    @submit="onSubmit"
                    @failed="onFailed"
            >
                <van-cell-group>

                    <van-field
                            v-model="formData.name"
                            :rules="[{ required: true, message: '不能为空' }]"
                            label="学校/班级名称"
                            input-align="right"
                            error-message-align="right"
                            clearable
                            placeholder="请输入学校/班级名称"
                    />


                </van-cell-group>



                <div class="savebtn">
                    <van-button
                            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                            style="width: 3rem"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." >保存</van-button>
                </div>
            </van-form>


        </van-popup>


        <div class="shareShow" v-if="showWxShare" @click="showWxShare=false">
            <div>
                <h2>点击分享给好友(朋友圈)</h2>
            </div>
        </div>


        <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }" >
            <div class="share-panel">
                <div class="share-title">请选择分享方式</div>
                <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
                <div class="share-ul">
                    <div class="share-weixin" @click="shareWeixinFriend">
                        <p>微信好友</p>
                    </div>
                    <div class="share-timeline" @click="shareWeixinTimeLine">
                        <p>朋友圈</p>
                    </div>
                    <div class="share-copy" v-clipboard:copy="copy_text" v-clipboard:success="function(){copySuccess();show_share_panel=false }" >
                        <p>复制链接</p>
                    </div>
                </div>
            </div>
        </van-popup>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

    .list-box {
        padding-top: 0.2rem;
        /*background: rgba(248,248,248,1);*/
    }

    .goods-line {
        height: 55px;
    }

    .goods-bottom-line {
        width: 100%;
        position: fixed;
        height: 60px;
        bottom: 0;
        background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
    }

    .goods-create-btn {
        position: fixed;
        bottom: 10px;
        width: 100%;
        height: 44px;
        font-size: 16px;
        text-align: center;
    }

    .goods-create-btn button {
        width: 3.2rem;
    }

    .goods-create-btn img {
        width: 60px;
        height: 60px;
    }

    .goods-header {
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        z-index: 99;
        width: 100%;
        margin-bottom: 0.01rem;
        background: #fff;
    }

    .van-tabs {
        width: 85% !important;
    }

    .screen-btn {
        line-height: 44px;
        height: 44px;
    }

    .screen-btn img {
        width: 45%;
        padding-left: 15px;
        vertical-align: middle;
        border-left: 1px solid #D5D5D5;
    }

    .sidebar {
        padding-top: 15px;
    }

    .search-box img {
        width: 60px;
        height: 60px;
    }


    .select-btn {
        position: fixed;
        bottom: 0;
        width: 90%;
        margin: 0 auto;
        padding: 0px 15px 30px;
    }

    .btn-reset {
        padding-bottom: 10px;
    }

    .btn-reset >>> .van-button {
        background: #ddd;
    }

    .selected {
        color: #444;
    }


    .lists {
        padding: 0.2rem;
        border-radius:10px;
        background: #fff;
        margin: 0 0.2rem 0.2rem;
    }

    .rights {
        position: relative;
        height: 1rem;
    }

    .rights .title{
        font-size: 15px;
        font-weight: bold;
    }
    .rights .desc{
        font-size: 12px;
        padding-top: 10px;
        color: #999;
    }



</style>

<script>
    import Vue from 'vue';

    import {Cell, CellGroup, Toast, Dialog, Icon,Popup, PullRefresh,ActionSheet, List, Tag, Button,DropdownMenu, DropdownItem} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Popup).use(ActionSheet).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem);
    export default {
        name: 'ExameApplyShareList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        data: function () {
            return {
                showAddForm:false,
                actionShow:false,
                showWxShare:false,
                show_share_panel:false,
                copy_text:'',
                list: [],
                formData: {
                    id:0,
                    kaoji_id:this.$route.query.kaoji_id,
                    name: ''
                },
                actions:[
                    { name: '新增考生' },
                    { name: '编辑' },
                    { name: '分享' },
                    { name: '删除' },
                ],
                isLoading: false,
                saveLoading: false,
                loading: false,
                finished: false,

            }
        },
        mounted() {
            document.title = "考级中心考级点"
            this.getList();
        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/qcxj/kaojiApplyShareList', {
                    kaoji_id: that.formData.kaoji_id
                }, (res) => {
                    that.list =  res.data ;
                })
            },

            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            onSubmit(values){
                let that = this;
                console.log(that.formData)
                that.saveLoading = true;

                that.$api.post('/api/qcxj/kaojiApplyShareSave', that.formData, (res) => {
                    that.saveLoading = false;
                    that.showAddForm =false;
                    that.formData.name ='';
                    that.getList();
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            action(item,index){
                this.actionShow = true;
                this.formData.id = item.id;
                this.formData.name = item.name;
            },
            shareWeixinFriend(share_data){
                console.log('shareWeixinFriend')
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinFriend',
                        query: share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;
                    that.wxShare(share_data.title,share_data.desc,share_data.url,share_data.pic_url );
                }
            },


            shareWeixinTimeLine(share_data){
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinTimeLine',
                        query: share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;

                }
            },

            onActionSelect(action,index){
                let that = this;
                switch (index){
                    case 0 :
                        //新增
                        rbLink({
                            name:'ExameApplyMemberAdd',
                            query:{
                                kaoji_id:that.formData.kaoji_id,
                                share_id:that.formData.id
                            }
                        })
                        break;
                    case 1 :
                        //编辑
                            this.showAddForm = true;
                            this.actionShow = false;
                        break;
                    case 2 :
                        //分享
                        that.$api.post('/api/qcxj/kaojiApplyShareData', {
                            id:that.formData.id
                        }, (res) => {
                            that.shareWeixinFriend(res.data);
                        }, (res) => {
                            Toast.fail(res.msg);
                        })
                        break;
                    case 3 :
                        //删除

                        Dialog.confirm({
                            title: '确认',
                            message: '是否删除邀请卡?',
                        })
                                .then(() => {
                                    // on confirm
                                    that.$api.post('/api/qcxj/kaojiApplyShareDelete', {
                                        id:that.formData.id
                                    }, (res) => {
                                        that.getList();
                                    }, (res) => {
                                        Toast.fail(res.msg);
                                    })

                                })
                                .catch(() => {
                                    // on cancel
                                });

                        this.actionShow = false;
                        break;

                }
            }


        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyShareList.vue?2bae5eb6